import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/styles';
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, Grow, Backdrop, CircularProgress, DialogContentText, Tooltip, ClickAwayListener } from '@material-ui/core';
import { Home, Place, RestaurantMenu, KingBed, Info, EmojiFoodBeverage } from '@material-ui/icons';
import clsx from 'clsx';

import { setAlertMessage } from '../../menu/menu.actions';
import { styles } from './styles/orderModal.styles';

import { verifyTokenAndSession, closeScanModal, setCurrOpenedModal, setOrderModalState } from './../../qr-scan/actions/scan.actions';
import { verifyOpenedPlace, setChosenPlace } from './../../places/actions/places.actions';
import { makeSystemLog } from './../../tracking/actions/tracking.actions';

import OrderModalSpot from './OrderModal/OMSpot';
import OrderModalDelivery from './OrderModal/OMDelivery';
import OrderModalPreorder from './OrderModal/OMPreorder';
import OrderModalServedOnSpot from './OrderModal/OMServedOnSpot';
import OrderModalRoom from './OrderModal/OMRoom';
import Utils from "../../utils/Utils";
import Auth from "../../utils/Auth";
import SnackbarContent from '@material-ui/core/SnackbarContent';

import { applyPromocode } from './../../promocodes/promocodes.actions'
import ORDER_TYPES from "../../enums/orderTypes";

class OrderModal extends Component {
    constructor(props) {
        super(props);

        const order_credentials = window.localStorage.getItem('order_credentials');
        const loggedUser = this.props.loggedUser;

        this.dialogContentRef = React.createRef();

        this.state = {
            // termsOpened: false,
            // privacyPolicyOpened: false,
            alertMessage: '',
            name: order_credentials ? (JSON.parse(order_credentials).name || "") : (loggedUser ? loggedUser.fullname : ''),
            phone: order_credentials ? (JSON.parse(order_credentials).phone || "") : loggedUser ? loggedUser.phone : '',
            address: order_credentials ? (JSON.parse(order_credentials).address || "") : loggedUser ? loggedUser.address : '',
            email: order_credentials ? (JSON.parse(order_credentials).email || "") : loggedUser ? loggedUser.email : '',

            addressDetails: '',
            streetNumber: '',
            floorNumber: '',
            apNumber: '',
            bellNumber: '',
            entranceNumber: '',
            postalCode: '',
            // name: loggedUser ? (loggedUser.fullname || "") : order_credentials ? JSON.parse(order_credentials).name : '',
            // phone: loggedUser ? loggedUser.phone : order_credentials ? JSON.parse(order_credentials).phone : '',
            // address: loggedUser ? loggedUser.address : order_credentials ? JSON.parse(order_credentials).address : '',
            // email: loggedUser ? loggedUser.email : order_credentials ? JSON.parse(order_credentials).email : '',

            room_number: order_credentials ? JSON.parse(order_credentials).room_number : '',
            promoCode: '',
            promoCodeApplied: 0,
            rememberMe: order_credentials ? true : false,
            inputPromoCodeVisible: false,
            payment_method: order_credentials ? JSON.parse(order_credentials).payment_method : '',
            additional_order_type: '',
            payment_instrument: '',
            cutlery: order_credentials ? JSON.parse(order_credentials).cutlery : '',
            count_cutlery: 0,
            // terms: false,
            // privacy_policy: false,
            errors: '',
            modalType: 0,

            orderDate: '',
            orderTime: '',
            orderTextComment: '',

            regionId: order_credentials ? JSON.parse(order_credentials).regionId : '',
            deliveryRadiusId: null,
            deliveryShapeId: null,
            lat: null,
            lng: null,

            scanDelay: 200,
            scannedTableToken: '',
            scanLegacyMode: false,
            scanned: false,

            customErrors: {},
            formSubmissionFailed: false,

            promocodeTooltipOpened: false,
            subscribe_for_lunch_menu: 0,
            free_product: null,
            pickupPlaceId: null,
            addressCleared: 0, // Used for flag for clearing address only once. Otherwize докато пишеш адреса може да го изтрие като мине componentWillReceiveProps
            required_checkbox_in_order_modal: false,
            required_checkbox_in_order_modal_2: false,
            accumulatedOrderAmountUsed: false,
            delivery_address_lat: 0,
            delivery_address_lng: 0,
        }
    }

    componentDidMount() {
        let newState = { errors: '' }
        this.autoSetClientAddressOnPreOrder(this.props);

        if (Auth.getRoomNumDisabled() && Auth.getRoomNumInToken()) {
            newState.room_number = Auth.getRoomNumInToken()
        }

        this.setState(newState);
    }

    componentWillReceiveProps(nextProps) {
        // this.autoSetClientAddressOnPreOrder(props);
        // const { settings } = this.props;
        const { open, settings } = this.props

        // if (this.props.orderSent == 'true' && this.props.orderMessage.length > 0 && this.state.privacy_policy) {
        //     this.setState({ privacy_policy: false });
        // }

        // Bugfix saved regions from other place
        if (!(this.props.regions && this.props.regions.length > 0) && this.state.regionId
            && settings && settings.logo && settings.logo.value) { // To make sure regions are not loaded
            this.setState({ regionId: '' })
        }

        this.calculatePossibleOrderDateAndTimes(nextProps.currOpenedModal);
        // console.log("STATE ", this.state, this.state.name && this.state.name.length == 0 && this.state.phone && this.state.phone.length == 0)
        // console.log('typeof this.state.name != "undefined"', typeof this.state.name, typeof this.state.name != "undefined");
        // if ((typeof this.state.name == "undefined" || this.state.name.length == 0) && (typeof this.state.phone == "undefined" || this.state.phone.length == 0)) {

        let order_credentials = window.localStorage.getItem('order_credentials');
        if (order_credentials) {
            order_credentials = JSON.parse(order_credentials);
        }
        let userAddresses = window.localStorage.getItem('tabl_user_addresses');
        if (userAddresses) {
            userAddresses = JSON.parse(userAddresses);
        }

        if ((typeof this.state.name == "undefined" || (!this.state.name))
            && (typeof this.state.phone == "undefined" || (!this.state.phone))
            && (typeof this.state.address == "undefined" || (!this.state.address))
            && (typeof this.state.email == "undefined" || (!this.state.email))
        ) {

            const loggedUser = nextProps.loggedUser;
            this.setState({
                name: order_credentials ? (order_credentials.name || "") : loggedUser ? loggedUser.fullname : '',
                phone: order_credentials ? (order_credentials.phone || "") : loggedUser ? loggedUser.phone : '',
                address: order_credentials ? (order_credentials.address || "") : loggedUser ? loggedUser.address : '',
                email: order_credentials ? (order_credentials.email || "") : loggedUser ? loggedUser.email : '',
                // phone: loggedUser ? loggedUser.phone : order_credentials ? JSON.parse(order_credentials).phone : '',
                // address: loggedUser ? loggedUser.address : order_credentials ? JSON.parse(order_credentials).address : '',
                // email: loggedUser ? loggedUser.email : order_credentials ? JSON.parse(order_credentials).email : '',
            })
        }

        if (nextProps.settings && nextProps.settings.subscribe_for_lunch_menu_visible && nextProps.settings.subscribe_for_lunch_menu_visible.value == 1) {
            this.setState({
                subscribe_for_lunch_menu: 1
            })
        }

        // логика за сетване на адрес(delivery Shape) ако тя е била Запомнена (Запомни ме)
        if (nextProps.deliveryShapes && nextProps.deliveryShapes.length > 0) {
            if (this.state.deliveryShapeId == null) {
                if (order_credentials && order_credentials.deliveryShapeId
                    && nextProps.deliveryShapes.find(d => d.id == order_credentials.deliveryShapeId)
                    && userAddresses && Object.values(userAddresses).length == 1
                ) {
                    this.setState({
                        deliveryShapeId: order_credentials.deliveryShapeId,
                        streetNumber: order_credentials.streetNumber,
                        floorNumber: order_credentials.floorNumber,
                        apNumber: order_credentials.apNumber,
                        bellNumber: order_credentials.bellNumber,
                        entranceNumber: order_credentials.entranceNumber,
                    })
                } else {
                    if (!this.state.addressCleared) {
                        this.setState({
                            address: "",
                            addressCleared: 1
                        })
                    }
                }
            }
        }

    }

    // componentWillUnmount() {
    // }

    componentDidUpdate() {
        // this.handleChooseOrderTypeModal();
    }


    handleChooseOrderTypeModal = (orderType) => {
        const { settings, translations, productsToOrder, productIngredients } = this.props;
        const disabledOrdering = Utils.disabledOrdering(settings);

        if (disabledOrdering) {
            this.props.onError(Utils.getDisabledOrderingMessage(translations, settings))
            return;
        }

        const cartPrice = Utils.calculateTotalPriceForOrder(productsToOrder, settings, productIngredients, (orderType == 'delivery' || orderType == 'preorder'))
        const minimal_order_price = parseFloat(Utils.getSettingsValue(settings, 'minimal_order_price'))

        // IF Delivery radiuses are ON, use their min order price; Ще се смята при бутона поръчай, а не при избора на тип поръчка
        if (orderType == 'delivery' && !Utils.getDeliveryRadiuses() && cartPrice < minimal_order_price) {
            this.props.setAlertMessage(true, Utils.translate(translations && translations.pages && translations.pages.cart_delivery && translations.pages.cart_delivery.minimal_order_price ? translations.pages.cart_delivery.minimal_order_price : '', { value: minimal_order_price + ' ' + (settings.default_currency_suffix && settings.default_currency_suffix.value ? settings.default_currency_suffix.value : 'лв.') }))
            this.setState({ alertMessage: Utils.translate(translations && translations.pages && translations.pages.cart_delivery && translations.pages.cart_delivery.minimal_order_price ? translations.pages.cart_delivery.minimal_order_price : '', { value: minimal_order_price + ' ' + (settings.default_currency_suffix && settings.default_currency_suffix.value ? settings.default_currency_suffix.value : 'лв.') }) })
            return;
        } else {
            this.setState({ alertMessage: '' })
        }

        if (orderType == 'spot') {
            if (Auth.getUserToken()) {
                this.props.onSubmit(this.state, 1);
            } else {
                if (window.localStorage.getItem("app")) {
                    window.location.pathname = "/close-browser-app";
                    return;
                }
            }
        }
        this.props.setCurrOpenedModal(orderType);
        this.setState({ promoCodeApplied: false, promoCode: '' })
    }

    autoSetClientAddressOnPreOrder = (props) => {
        const { open, settings } = props
        // Set place address if preorder


        if (open == true && (((this.props.chosenPlaceOrderTypes.findIndex(p => p.type == "preorder") > -1))) && (settings.place_address && settings.place_address.value) && ((!this.state.address) || this.state.address && this.state.address != settings.place_address.value)) {
            this.setState({ address: settings.place_address.value });
        }
    }

    setCutleryItemsCount = (countCutlery) => {
        this.setState({ count_cutlery: countCutlery })
    }

    submitOrder = (currentOrderType, changePaymentInstrument = false) => {
        if(currentOrderType === ORDER_TYPES.ROOM && !Auth.getRoomNumInToken() && Utils.getSetting('disable_room_order_if_not_scanned') == 1) {
            this.props.onError(this.props.translations.messages.errors.please_scan_qr_code_to_order)
            return;
        }

        if (Utils.disabledOrdering(this.props.settings)) {
            this.props.onError(Utils.getDisabledOrderingMessage(this.props.translations, this.props.settings))
        } else {
            let currState = this.state;

            if (changePaymentInstrument) {
                currState.payment_instrument = '';
                this.setState(currState)
            }

            if (this.isFormValid({}, true)) {

                // Adding regions in address, because address is used as main field and will be easier to be in it.
                if (this.state.regionId) {
                    const regionName = this.props.regions.find(r => r.id == this.state.regionId)
                    const validAddress = currState.address.indexOf('/ Район:') != -1 ? this.state.address.split('/ Район:')[0] : currState.address
                    currState.address = validAddress + ' / Район: ' + (regionName.name)
                }

                if (Utils.getSettingsValue(this.props.settings, 'include_cutlery_and_comment_in_address') == 1) {
                    const validName = this.state.name.indexOf('/ Прибори:') != -1 ? this.state.name.split('/ Прибори:')[0] : this.state.name;
                    currState.name = validName + ' / Прибори: ' + (currState.cutlery == 1 ? 'ДА' : 'НЕ') + ' / Коментар: ' + currState.orderTextComment + ' ' // Do not change the label: 'Прибори' it's used in the file
                }

                if (Utils.getSettingsValue(this.props.settings, 'additional_price_each_cutlery') && Utils.getSettingsValue(this.props.settings, 'additional_price_each_cutlery') != '0') {
                    currState.cutlery = 0;
                }

                // console.log('this.props.omdata', this.props.omdata);
                // console.log('currState', currState);

                this.props.onSubmit(currState, currentOrderType)
            }

            if (this.state.rememberMe) {
                this.saveOrderInfoToLocal()
            } else {
                this.removeOrderInfoFromLocal();
            }
        }
    }



    isFormValid = (updatedValue = {}, submitOrder = false) => {
        const { settings } = this.props;

        const payment_methods_for_order_types = Utils.getSettingsValue(settings, 'payment_methods_for_order_types') || {};

        const checkMinLengthValid = (value) => {
            const minLength = 3;
            return value && value.toString().length >= minLength;
        }

        let stateData = this.state;

        // Used for live validate onchange (Because state is not changed immediately)
        if (updatedValue && Object.keys(updatedValue).length > 0 && Object.keys(updatedValue)[0]) {
            stateData[Object.keys(updatedValue)[0]] = updatedValue[Object.keys(updatedValue)[0]];
        }

        // Name
        const nameValid = checkMinLengthValid(stateData.name) && stateData.name.toString().length <= 100;

        // Phone
        let phoneValid = checkMinLengthValid(stateData.phone) && stateData.phone.toString().length <= 100;
        const phoneRegexMatch = Utils.getSettingsValue(settings, 'validate_phone_number_regex') && stateData.phone ? (new RegExp(Utils.getSettingsValue(settings, 'validate_phone_number_regex'))).test(stateData.phone.replace(/ /g, '')) : true;
        phoneValid = Utils.getSettingsValue(settings, 'order_model_phone_placeholder') ? true : (phoneValid && phoneRegexMatch);

        // Custom Field Valid
        const customFieldValid = Utils.getSettingsValue(settings, 'order_model_phone_placeholder') ? (stateData.phone.toString().length >= 1 && stateData.phone.toString().length <= 50) : true;

        const customFieldValidAddress = Utils.getSettingsValue(settings, 'order_model_address_placeholder') ? (stateData.address.toString().length >= 1 && stateData.address.toString().length <= 150) : true;

        const validateEmail = (email) => {
            // // check for @ sign
            // var atSymbol = email.indexOf("@");
            // if (atSymbol < 1) return false;

            // var dot = email.indexOf(".");
            // if (dot <= atSymbol + 2) return false;

            // // check that the dot is not at the end
            // if (dot === email.length - 1) return false;

            // return true;

            if (email && email.length > 345) {
                return false;
            }

            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

            if (email.match(validRegex)) {

                //   alert("Valid email address!");

                //   document.form1.text1.focus();

                return true;

            } else {

                //   alert("Invalid email address!");

                //   document.form1.text1.focus();

                return false;

            }



        }

        // email
        let emailValid = Utils.getSettingsValue(settings, 'email_required_when_ordering') == '1' ? validateEmail(stateData.email) : true;

        // Address - DELIVERY ONLY
        let addressValid = this.props.currOpenedModal == 'delivery' ? checkMinLengthValid(stateData.address) && stateData.address.toString().length <= 300 : true;

        let streetNumberValid = true;
        let floorNumberValid = true;
        let apNumberValid = true;
        let bellNumberValid = true;
        let entranceNumberValid = true;

        let streetNumberLengthValid = true;
        let floorNumberLengthValid = true;
        let apNumberLengthValid = true;
        let bellNumberLengthValid = true;
        let entranceNumberLengthValid = true;

        // Region - DELIVERY ONLY    UPDATE 23.04.22 ADDED GOOGLE MAPS -> check for regions only when google maps address is not active
        const regionsValid = (this.props.currOpenedModal == 'delivery' && this.props.regions.length > 0 && Utils.getDeliveryRadiuses() == null && Utils.getDeliveryShapes() == null) ? (stateData.regionId && this.props.regions.find(r => r.id == stateData.regionId) ? true : false) : true;

        // For don fernandez functionality; Only if masterPlace is active -> check for pickupPlaceId chosen
        const pickupPlaceValid = this.props.currOpenedModal == 'preorder' && this.props.client && this.props.client.masterPlace ? (stateData.pickupPlaceId != null ? true : false) : true;

        // Order Date
        const orderDateValid = stateData.orderDate.toString().length > 0 || this.defaultOrderDate.toString().length > 0

        // Order Time
        let orderTimeValid = stateData.orderTime.toString().length > 0;

        // console.log(stateData.orderDate, stateData.orderTime, 'VALID ', orderDateValid, orderTimeValid);
        // return false;
        // Text comment
        let isTextCommentValid = stateData.orderTextComment.toString().length < 500;

        if (!orderTimeValid && Utils.getSettingsValue(settings, 'required_delivery_pickup_times') != '1') {
            orderTimeValid = this.defaultOrderTime;
        }

        if (stateData.orderTime && stateData.orderTime.length > 0 && stateData.orderTime.indexOf(':') != -1) {
            let currDate = new Date();
            let selectedDate = new Date();

            if (stateData.orderTime && stateData.orderTime.indexOf(':') != -1) {
                selectedDate.setHours(stateData.orderTime.split(':')[0]);
                selectedDate.setMinutes(stateData.orderTime.split(':')[1]);
            }

            if (stateData.orderDate && stateData.orderDate.indexOf('.') != -1) {
                selectedDate.setDate(stateData.orderDate.split('.')[1]);
                selectedDate.setMonth(parseInt(stateData.orderDate.split('.')[0]) - 1);
            }

            if (
                selectedDate.getTime() - currDate.getTime() < 1800000) { // 30 mins
                orderTimeValid = false; // The user waited too much before order - AND ORDER DATE IS TODAY
            }
        }


        // Room number - Room
        const roomNumberValid = this.props.currOpenedModal == 'room'
            ? ((stateData.room_number)
                ? true
                : (Auth.getRoomNumDisabled() && Auth.getRoomNumInToken()
                    ? true : false)
            ) : true;

        // Payment type - Delivery
        const paymentValidDelivery = (payment_methods_for_order_types && payment_methods_for_order_types[this.props.currOpenedModal] && payment_methods_for_order_types[this.props.currOpenedModal].length > 0 && this.props.currOpenedModal == 'delivery') ? (stateData.payment_method.length > 0) : true

        // Payment type - Pickup
        const paymentValidPickup = (payment_methods_for_order_types && payment_methods_for_order_types[this.props.currOpenedModal] && payment_methods_for_order_types[this.props.currOpenedModal].length > 0 && this.props.currOpenedModal == 'preorder') ? (stateData.payment_method.length > 0) : true

        // Payment type - Room
        const paymentValidRoom = (payment_methods_for_order_types && payment_methods_for_order_types[this.props.currOpenedModal] && payment_methods_for_order_types[this.props.currOpenedModal].length > 0 && this.props.currOpenedModal == 'room') ? (stateData.payment_method.length > 0) : true

        // Cutlery - Delivery
        const cutlerySelectedDelivery = ((Utils.getSettingsValue(settings, 'show_cutlery_option_on_making_delivery_order') == '1' && this.props.currOpenedModal == 'delivery')) ? ((Utils.getSettingsValue(settings, 'additional_price_each_cutlery') && Utils.getSettingsValue(settings, 'additional_price_each_cutlery') != '0') ? true : (stateData.cutlery != '')) : true

        // Cutlery - Pickup
        const cutlerySelectedPickup = ((Utils.getSettingsValue(settings, 'show_cutlery_option_on_making_preorder_order') == '1' && this.props.currOpenedModal == 'preorder')) ? ((Utils.getSettingsValue(settings, 'additional_price_each_cutlery') && Utils.getSettingsValue(settings, 'additional_price_each_cutlery') != '0') ? true : (stateData.cutlery != '')) : true

        // Cutlery - Room
        const cutlerySelectedRoom = ((Utils.getSettingsValue(settings, 'show_cutlery_option_on_making_room_order') == '1' && this.props.currOpenedModal == 'room')) ? (stateData.cutlery != '') : true

        // Additional order type - Room (only room for now)
        const additionalOrderTypeValidRoom = ((Utils.getSettingsValue(settings, 'allow_additional_order_type_room') == '1' && this.props.currOpenedModal == 'room')) ? stateData.additional_order_type.length > 0 : true;

        // // Terms
        // const termsValid = stateData.terms == true;

        // Privacy Policy
        // const privacyPolicyValid = stateData.privacy_policy == true;

        let requiredCheckboxInOrderModalChecked = true;
        if (settings.required_checkbox_in_order_modal && settings.required_checkbox_in_order_modal.value && settings.required_checkbox_in_order_modal.value.length > 0) {
            requiredCheckboxInOrderModalChecked = stateData.required_checkbox_in_order_modal ?? false;
        }

        let requiredCheckboxInOrderModal2Checked = true;
        if (settings.required_checkbox_in_order_modal_2 && settings.required_checkbox_in_order_modal_2.value && settings.required_checkbox_in_order_modal_2.value.length > 0) {
            requiredCheckboxInOrderModal2Checked = stateData.required_checkbox_in_order_modal_2 ?? false;
        }

        // DELIVERY - MIN ORDER PRICE BY RADIUS
        if ((Utils.getDeliveryRadiuses() || Utils.getDeliveryShapes()) && this.props.currOpenedModal == 'delivery') {

            if (!stateData.deliveryRadiusId && !stateData.deliveryShapeId) {
                addressValid = false;
            }
            if (!stateData.streetNumber) {
                streetNumberValid = false;
            }
            if (stateData.streetNumber.length > 10) {
                streetNumberLengthValid = false;
            }

            if (Utils.getSettingsValue(settings, 'make_required_all_address_fields') == 1) {
                if (!stateData.floorNumber) {
                    floorNumberValid = false;
                }
                if (stateData.floorNumber.length > 10) {
                    floorNumberLengthValid = false;
                }

                if (!stateData.apNumber) {
                    apNumberValid = false;
                }
                if (stateData.apNumber.length > 10) {
                    apNumberLengthValid = false;
                }

                if (!stateData.bellNumber) {
                    bellNumberValid = false;
                }
                if (stateData.bellNumber.length > 10) {
                    bellNumberLengthValid = false;
                }

                if (!stateData.entranceNumber) {
                    entranceNumberValid = false;
                }
                if (stateData.entranceNumber.length > 10) {
                    entranceNumberLengthValid = false;
                }
            }
            // let currDeliveryRadius = Utils.getDeliveryRadiuses().find(r => r.id == stateData.deliveryRadiusId);
            // console.log("STATE DATA", stateData, currDeliveryRadius)

            // if(currDeliveryRadius) {
            //     Utils
            // }
        }

        if (Utils.getSettingsValue(settings, 'use_google_location_coordinates') == 1 && this.state.delivery_address_lat && this.state.delivery_address_lng) {
            console.log('this.state', this.state);
            addressValid = true;
        }

        const isFormValid = nameValid && phoneValid && customFieldValid && customFieldValidAddress && emailValid && addressValid && streetNumberValid && floorNumberValid && apNumberValid && bellNumberValid && entranceNumberValid && streetNumberLengthValid && floorNumberLengthValid && apNumberLengthValid && bellNumberLengthValid && entranceNumberLengthValid && regionsValid && orderDateValid && orderTimeValid && roomNumberValid && paymentValidDelivery && paymentValidPickup && paymentValidRoom && cutlerySelectedDelivery && cutlerySelectedPickup && cutlerySelectedRoom && additionalOrderTypeValidRoom && isTextCommentValid && pickupPlaceValid && requiredCheckboxInOrderModalChecked && requiredCheckboxInOrderModal2Checked; /*&& termsValid && privacyPolicyValid*/

        if (isFormValid) {
            this.setState({ customErrors: {} });
        } else {
            this.setState({
                formSubmissionFailed: true,
                customErrors:
                {
                    name: !nameValid ? this.props.translations.messages.errors.invalid_name : '',
                    email: !emailValid ? this.props.translations.messages.errors.invalid_email : '',
                    phone: !phoneValid ? this.props.translations.messages.errors.invalid_phone : '',
                    invalid_phone_field: !customFieldValid ? this.props.translations.messages.errors.invalid_field : '',
                    invalid_address_field: !customFieldValidAddress ? this.props.translations.messages.errors.invalid_field : '',
                    address: !addressValid ? this.props.translations.messages.errors.invalid_address : '',
                    streetNumber: !streetNumberValid ? this.props.translations.messages.errors.invalid_street_number : !streetNumberLengthValid ? this.props.translations.messages.errors.invalid_street_number_length : '',

                    floorNumber: !floorNumberValid ? this.props.translations.messages.errors.invalid_floor_number : !floorNumberLengthValid ? this.props.translations.messages.errors.invalid_floor_number_length : '',
                    apNumber: !apNumberValid ? this.props.translations.messages.errors.invalid_ap_number : !apNumberLengthValid ? this.props.translations.messages.errors.invalid_ap_number_length : '',
                    bellNumber: !bellNumberValid ? this.props.translations.messages.errors.invalid_bell_number : !bellNumberLengthValid ? this.props.translations.messages.errors.invalid_bell_number_length : '',
                    entranceNumber: !entranceNumberValid ? this.props.translations.messages.errors.invalid_entrance_number : !entranceNumberLengthValid ? this.props.translations.messages.errors.invalid_entrance_number_length : '',

                    regionId: !regionsValid ? this.props.translations.messages.errors.invalid_regionId : '',
                    orderDate: !orderDateValid ? this.props.translations.messages.errors.invalid_orderDate : '',
                    orderTime: !orderTimeValid ? this.props.translations.messages.errors.invalid_orderTime : '',
                    room_number: !roomNumberValid ? this.props.translations.messages.errors.invalid_room_number : '',
                    payment_method: !(paymentValidDelivery && paymentValidPickup && paymentValidRoom) ? this.props.translations.messages.errors.invalid_payment_method : '',
                    cutlery: !(cutlerySelectedDelivery && cutlerySelectedPickup && cutlerySelectedRoom) ? this.props.translations.messages.errors.invalid_cutlery_selected : '',
                    additional_order_type: !additionalOrderTypeValidRoom ? this.props.translations.messages.errors.invalid_additional_order_type : '',
                    text_comment: !isTextCommentValid ? this.props.translations.messages.errors.invalid_text_comment : '',
                    pickupPlaceId: !pickupPlaceValid ? this.props.translations.messages.errors.invalid_pickup_place : '',
                    required_checkbox_in_order_modal: !requiredCheckboxInOrderModalChecked ? this.props.translations.messages.errors.invalid_required_checkbox_in_order_modal : '',
                    required_checkbox_in_order_modal_2: !requiredCheckboxInOrderModal2Checked ? this.props.translations.messages.errors.invalid_required_checkbox_in_order_modal_2 : ''
                    // terms: !termsValid ? this.props.translations.messages.errors.invalid_terms : '',
                    // privacy_policy: !privacyPolicyValid ? this.props.translations.messages.errors.invalid_privacy_policy_and_terms : '',
                }
            });

            if (submitOrder && this.dialogContentRef && this.dialogContentRef.current) {
                this.dialogContentRef.current.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }

        }

        return isFormValid;
    }

    saveOrderInfoToLocal = () => {
        let order_credentials = {};

        order_credentials.name = this.state.name.indexOf('/ Прибори:') != -1 ? this.state.name.split('/ Прибори:')[0] : this.state.name
        order_credentials.address = this.state.address.indexOf('/ Район:') != -1 ? this.state.address.split('/ Район:')[0] : this.state.address
        order_credentials.phone = this.state.phone;
        order_credentials.room_number = this.state.room_number;
        order_credentials.email = this.state.email;
        order_credentials.regionId = this.state.regionId;
        order_credentials.payment_method = this.state.payment_method;
        order_credentials.cutlery = this.state.cutlery;
        order_credentials.deliveryShapeId = this.state.deliveryShapeId;
        order_credentials.streetNumber = this.state.streetNumber;
        order_credentials.floorNumber = this.state.floorNumber;
        order_credentials.apNumber = this.state.apNumber;
        order_credentials.bellNumber = this.state.bellNumber;
        order_credentials.entranceNumber = this.state.entranceNumber;

        window.localStorage.setItem('order_credentials', JSON.stringify(order_credentials));
    }

    removeOrderInfoFromLocal = () => {
        window.localStorage.removeItem('order_credentials');
    }

    handleScan = (scannedTableToken) => {
        const { onClose, onSubmit, onError, translations } = this.props;

        if (scannedTableToken) {
            if (this.state.scanned == false) {
                this.setState({ scanned: true });

                this.props
                    // .verifyToken(scannedTableToken)
                    .verifyTokenAndSession(scannedTableToken)
                    .then((data) => {
                        let validTokenSession = data.data.payload.session;

                        let placeId = data.data.payload.place_id;
                        this.props.verifyOpenedPlace(placeId); // if place is different -> clears local card, orders and token

                        Auth.setUserToken(validTokenSession);


                        let room_number = data.data.payload && data.data.payload.room_number ? data.data.payload.room_number : null;
                        if (room_number) {
                            Auth.setRoomNumInToken(room_number);
                        }

                        this.props.setChosenPlace(placeId);

                        let currState = this.state;
                        currState.scannedTableToken = validTokenSession;
                        if (data.data.payload.ordertype) {
                            Auth.setTokenOrderType(data.data.payload.ordertype);
                        }

                        onSubmit(currState, 1);
                        this.setState({ modalType: 0 });
                        this.props.closeScanModal();
                        // this.props.setCurrOpenedModal('multiple');
                        // this.props.setOrderModalState(0);

                        if (this.props.chosenPlace && this.props.chosenPlace.ordertypes.length > 1) {
                            this.props.setCurrOpenedModal('multiple');
                            // } else {
                            //     this.props.onClose();
                            //     this.props.setOrderModalState(0);
                        }

                        this.setState({ scanned: false });
                    })
                    .catch(err => {
                        console.log("FROM ORDER MODAL handle scan ERROR", err);

                        this.props.makeSystemLog('menu handleScan - verifyTokenAndSession', { 'error': err })

                        Auth.removeUserToken();
                        onError(translations.messages && translations.messages.errors && translations.messages.errors.order_sent_fail ? translations.messages.errors.order_sent_fail : 'Invalid token scanned');
                        this.setState({ modalType: 0 });
                        this.props.closeScanModal();

                        if (this.props.chosenPlace.ordertypes.length > 1) {
                            this.props.setCurrOpenedModal('multiple');
                        } else {
                            this.props.onClose();
                            this.props.setOrderModalState(0);
                        }

                        this.setState({ scanned: false });

                        // this.props.setCurrOpenedModal('multiple');
                        // this.props.onClose(); // няма да го затваряме за сега модала, и аз нз защо - аз зн
                    })
            }
        }

    }

    handleScanError = (err) => {
        console.error(err);
    }

    getOrderButtonId = (orderType) => {
        if (orderType == 'spot') {
            return 'choose-order-type-modal-inrestaurant-button';
        } else if (orderType == 'delivery') {
            return 'choose-order-type-modal-delivery-button';
        } else if (orderType == 'preorder') {
            return 'choose-order-type-modal-pickup-button';
        }
    }


    getOrderOptions = (currentPrice, selectedRegionDeliveryPrice) => {
        const { classes, fullWidth = false, maxWidth = 'xs', open, onClose, onSubmit, onError, isLoadingOrder, settings, modalData, translations, chosenPlace, productsToOrder, productIngredients, chosenPlaceOrderTypes } = this.props;
        const default_currency_suffix = (settings.default_currency_suffix && settings.default_currency_suffix.value ? settings.default_currency_suffix.value : 'лв.')
        const userToken = Auth.getUserToken();
        const disabledOrdering = Utils.disabledOrdering(settings);
        var orderOptions = "";

        if (chosenPlace) {
            let totalOrderTypeLength = Object.keys(chosenPlaceOrderTypes).length;

            if (chosenPlaceOrderTypes.findIndex(o => o.type == "tablet_mode" || o.type == "spot_browse") != -1) {
                totalOrderTypeLength--;
            }
            let count = 0;

            orderOptions = chosenPlaceOrderTypes.map((orderType, k) => {
                if (orderType.type == 'spot' && Utils.getSettingsValue(settings, 'hide_restaurant_orders_button_in_order_modal') == 1) {
                    return null;
                }

                if (orderType.type == "tablet_mode" || orderType.type == "spot_browse") { return null; }
                count++;

                // const currentPrice = parseFloat(Utils.calculateTotalPriceForOrder(productsToOrder, settings, productIngredients));
                const orderTypeDiscount = Utils.getOrderTypeDiscount(chosenPlace, orderType.type, currentPrice, 1)
                const orderTypePrice = Utils.getOrderTypePrice(chosenPlace, orderType.type, currentPrice, 1)

                let marginBottomOrderOptionButton = 0;

                if (Object.keys(orderTypeDiscount).length > 0) {
                    marginBottomOrderOptionButton += 15;
                }
                if ((this.props.regions.length > 0 && orderType.type == 'delivery') || (Object.keys(orderTypePrice).length > 0)) {
                    marginBottomOrderOptionButton += 15;
                }
                if (marginBottomOrderOptionButton == 50) {
                    marginBottomOrderOptionButton += 8
                }

                // (Object.keys(orderTypeDiscount).length > 0) && ((this.props.regions.length > 0 && orderType.type == 'delivery') || (Object.keys(orderTypePrice).length > 0)) ? 60 : ((Object.keys(orderTypeDiscount).length > 0 || Object.keys(orderTypePrice).length > 0) ? 40 : 20)
                return (
                    <Button key={k} id={this.getOrderButtonId(orderType.type)} size="large"
                        data-class={orderType.type + '_ordertypebutton'}
                        className={
                            (
                                (orderType.type == 'preorder' && Utils.getSettingsValue(settings, 'custom_text_under_preorder_button')) ||
                                (orderType.type == 'delivery' && Utils.getSettingsValue(settings, 'custom_text_under_delivery_button'))
                            )
                                ?
                                clsx(classes.modalTypesBtns, classes.marginBottomLargeButton)
                                :
                                classes.modalTypesBtns
                        }
                        style={{
                            borderBottom: (Object.keys(orderTypeDiscount).length == 0 && Object.keys(orderTypePrice).length == 0) || (this.props.regions.length > 0 && orderType.type == 'delivery' && this.state.regionId && selectedRegionDeliveryPrice == '0.00') ? '1px solid #ff5200' : 'none',
                            marginBottom: marginBottomOrderOptionButton,
                            gridColumn: (count == totalOrderTypeLength && count % 2 != 0) ? '1 / -1' : 'auto / span 1',
                        }}

                        onClick={() => this.handleChooseOrderTypeModal(orderType.type)}> {/* Go to scan page if not scanned, else make the order | If not spot open the modal with fields */}
                        <div>
                            {orderType.type == 'spot' ? <RestaurantMenu className={classes.modalTypesIcons} /> : null}
                            {orderType.type == 'delivery' ? <Home className={classes.modalTypesIcons} /> : null}
                            {orderType.type == 'preorder' ? <Place className={classes.modalTypesIcons} /> : null}
                            {orderType.type == 'room' ? 
                                // If there is a custom trans for Room order type, show table icon instead of room icon. (Used for Spain places)
                                Utils.getSettingsValue(settings, 'custom_translations') && Utils.getSettingsValue(settings, 'custom_translations').order_modal_room_order_option ?
                                    <RestaurantMenu className={classes.modalTypesIcons} />
                                    :
                                    <KingBed className={classes.modalTypesIcons} /> 
                                : 
                                null
                            }
                            {orderType.type == 'served_on_spot' ? <EmojiFoodBeverage className={classes.modalTypesIcons} /> : null}
                        </div>
                        <div>
                            {orderType.type == 'spot' && translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.order_type_restaurant : ''}
                            {orderType.type == 'delivery' && translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.order_type_delivery : ''}
                            {orderType.type == 'preorder' && translations.pages && translations.pages.cart_delivery && translations.pages.cart_delivery.order_type_preorder ? translations.pages.cart_delivery.order_type_preorder : ''}
                            {orderType.type == 'room' ? 
                                (Utils.getSettingsValue(settings, 'custom_translations') && Utils.getSettingsValue(settings, 'custom_translations').order_modal_room_order_option ? 
                                    Utils.getSettingsValue(settings, 'custom_translations').order_modal_room_order_option 
                                    : 
                                    (translations.pages && translations.pages.cart_delivery && translations.pages.cart_delivery.order_from_room ? 
                                        translations.pages.cart_delivery.order_from_room 
                                        : 
                                        ''
                                    )
                                ) : ''}
                            {orderType.type == 'served_on_spot' && translations.pages && translations.pages.cart_delivery && translations.pages.cart_delivery.served_on_spot ? translations.pages.cart_delivery.served_on_spot : ''}
                        </div>

                        {orderType.type == 'preorder' && Utils.getSettingsValue(settings, 'custom_text_under_preorder_button') ?
                            <div className={clsx(classes.modalTypesTexts, classes.bottom40)}>
                                {Utils.getSettingsValue(settings, 'custom_text_under_preorder_button')}
                            </div>
                            :
                            null
                        }
                        {orderType.type == 'delivery' && Utils.getSettingsValue(settings, 'custom_text_under_delivery_button') ?
                            <div className={clsx(classes.modalTypesTexts, classes.bottom40)}>
                                {Utils.getSettingsValue(settings, 'custom_text_under_delivery_button')}
                            </div>
                            :
                            null
                        }


                        {Object.keys(orderTypeDiscount).length > 0 ?
                            <div className={classes.modalTypesTexts}>
                                {orderTypeDiscount.value_type == 'money' ? orderTypeDiscount.value : parseInt(orderTypeDiscount.value)}{orderTypeDiscount.value_type == 'money' ? ' ' + default_currency_suffix : '%'} {translations && translations.common && translations.common.discount ? translations.common.discount : ''}
                            </div>
                            :
                            null
                        }

                        {(orderTypePrice && Object.keys(orderTypePrice).length > 0 && !Utils.getDeliveryRadiuses() ?
                            <div className={classes.modalTypesTexts} style={{ bottom: Object.keys(orderTypeDiscount).length > 0 ? -40 : -20 }}> {/* THIS IS orderTypeDiscount ! (not a copy mistake) */}
                                {parseFloat(orderTypePrice.value) == 0 ?
                                    (translations && translations.common && translations.common.free_del ? translations.common.free_del : '')
                                    :
                                    <React.Fragment>
                                        + {orderTypePrice.value} {default_currency_suffix}
                                    </React.Fragment>
                                }
                                &nbsp;{translations && translations.common && translations.common.delivery ? translations.common.delivery : ''}
                            </div>
                            :
                            (this.props.regions.length > 0 && orderType.type == 'delivery' ?
                                (parseFloat(selectedRegionDeliveryPrice) != 0 ?
                                    <div className={classes.modalTypesTexts} style={{ bottom: Object.keys(orderTypeDiscount).length > 0 ? -40 : -20 }}> {/* THIS IS orderTypeDiscount ! (not a copy mistake) */}
                                        + {selectedRegionDeliveryPrice} {default_currency_suffix} {translations && translations.common && translations.common.delivery ? translations.common.delivery : ''}
                                    </div>
                                    :
                                    <div className={classes.modalTypesTexts} style={{ bottom: Object.keys(orderTypeDiscount).length > 0 ? -40 : -20 }}> {/* THIS IS orderTypeDiscount ! (not a copy mistake) */}
                                        {translations && translations.pages && translations.pages.cart_delivery && translations.pages.cart_delivery.price_according_to_region ? translations.pages.cart_delivery.price_according_to_region : ''}
                                    </div>
                                )
                                :
                                null
                            )
                        )}


                    </Button>
                )

            })
        }
        return orderOptions;
    }

    checkTimeMatch = (data, timeToMatch, settingsMaxOrdersCount) => {
        if (timeToMatch.indexOf(' ') !== -1) {
            timeToMatch = timeToMatch.split(' ')[0]
        }

        for (let i = 0; i < Object.values(data).length; i++) {
            let date = new Date(data[i].dateTime);
            let orderedOrderCountForTime = data[i].count;

            let timeStr = Utils.appendLeadingZeroes(date.getHours()) + ':' + Utils.appendLeadingZeroes(date.getMinutes())
            if (timeStr == timeToMatch) {

                for (let k = 0; k < Object.values(settingsMaxOrdersCount).length; k++) {
                    const maxOrdersCountSetting = Object.values(settingsMaxOrdersCount)[k];
                    const eachTimeMaxOrderCount = Object.keys(settingsMaxOrdersCount)[k];

                    let startTime = eachTimeMaxOrderCount.split(' - ')[0];

                    // Check if the startTime matches the timeStr
                    if (startTime === timeStr) {
                        if (orderedOrderCountForTime >= maxOrdersCountSetting) {
                            return true;
                        }
                    }
                }

            }
        }

        return false;
    }

    calculatePossibleOrderDateAndTimes = (currOpenedModal) => {
        const { translations, settings } = this.props;

        let orderDates = [];

        let currentHour = new Date().getHours();
        let currentMinutes = new Date().getMinutes();
        let currentDayInt = new Date().getDay();
        if (currentDayInt == 0) {
            currentDayInt = 7
        }

        function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }

        const enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal = Utils.getSettingsValue(settings, 'enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal');
        const minutes_margin_working_hours_choose_date_for_pickup_or_delivery_in_order_modal = parseInt(Utils.getSettingsValue(settings, 'minutes_margin_working_hours_choose_date_for_pickup_or_delivery_in_order_modal'));
        const add_more_hours_for_choosing_after_place_opened_working_hours = parseInt(Utils.getSettingsValue(settings, 'add_more_hours_for_choosing_after_place_opened_working_hours'));
        const add_more_hours_for_choosing_before_place_closed_working_hours = parseInt(Utils.getSettingsValue(settings, 'add_more_hours_for_choosing_before_place_closed_working_hours'));

        // For each 5 days shown
        for (let i = 0; i < 5; i++) {
            if (i > 0 && Utils.getSettingsValue(settings, 'allow_orders_only_for_today_when_choosing_datetime_for_order') == 1) { // Shows only "Днес/Today" in the dropdown for seelcting date for order
                break;
            }
            let eachDate = addDays(new Date(), i);

            let eachDateValue = Utils.appendLeadingZeroes(parseInt(parseInt(eachDate.getMonth()) + 1)) + '.' + Utils.appendLeadingZeroes(eachDate.getDate());
            let eachDateLabel = Utils.appendLeadingZeroes(eachDate.getDate()) + '.' + Utils.appendLeadingZeroes(parseInt(parseInt(eachDate.getMonth()) + 1));

            let disabledOrderingEachDay = Utils.disabledOrdering(settings, eachDate);
            if (disabledOrderingEachDay) {
                continue;
            }

            let label = eachDateLabel;

            let showDayInt = parseInt(currentDayInt) + parseInt(i);
            if (showDayInt > 7) showDayInt -= 7;

            if (i == 0) {
                label = translations.common && translations.common.date && translations.common.date.today ? translations.common.date.today + ' /' + label + '/' : '';
            } else if (i == 1) {
                label = translations.common && translations.common.date && translations.common.date.tommorow ? translations.common.date.tommorow + ' /' + label + '/' : '';
            } else {
                label = translations.common && translations.common.date && translations.common.date.day && translations.common.date.day[showDayInt] ? translations.common.date.day[showDayInt] + ' /' + label + '/' : '';
            }

            let eachDateHours = [];
            if (i == 0 && currOpenedModal != "served_on_spot") {
                eachDateHours.push('сега')
            }
            let minorderTimeHours = 0;
            let minorderTimeMinutes = 0;
            let maxorderTimeHours = 0;
            let maxorderTimeMinutes = 0;
            let currDayWorkingHours = Utils.getSettingsValue(settings, 'working_hours')[showDayInt];

            if (currDayWorkingHours && !disabledOrderingEachDay) {

                currDayWorkingHours = currDayWorkingHours.split('-');
                let minorderTime = currDayWorkingHours[0];
                minorderTimeHours = parseInt(minorderTime.split(':')[0]) + add_more_hours_for_choosing_after_place_opened_working_hours;
                minorderTimeMinutes = parseInt(minorderTime.split(':')[1]);

                let maxorderTime = currDayWorkingHours[1];
                maxorderTimeHours = parseInt(maxorderTime.split(':')[0]) - add_more_hours_for_choosing_before_place_closed_working_hours;
                maxorderTimeMinutes = parseInt(maxorderTime.split(':')[1]);
                let prevDataTime;
                let tempCount = 0;

                // For each hour
                for (let j = 0; j <= (maxorderTimeHours - minorderTimeHours); j++) {
                    // If today and current time is bigger than other times - Skip them
                    if (i == 0 && currentHour > (minorderTimeHours + j)) {
                        continue;
                    }

                    // For each 15 mins 
                    for (let k = 0; k < 60; k += minutes_margin_working_hours_choose_date_for_pickup_or_delivery_in_order_modal) {

                        let minK = 0;
                        let maxK = 60;
                        if (j == 0) {
                            minK = minorderTimeMinutes;
                        }
                        if (j == (maxorderTimeHours - minorderTimeHours)) {
                            maxK = maxorderTimeMinutes;
                        }

                        if ((k >= minK) && (k <= maxK)) {
                            tempCount++;

                            if (enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal == '1') {
                                if (tempCount == 1) {
                                    prevDataTime = minorderTimeHours + j + ':' + (Utils.appendLeadingZeroes(k)) + ' - '
                                    continue;
                                }
                            }

                            if (currentHour == (minorderTimeHours + j) && (currentMinutes + minutes_margin_working_hours_choose_date_for_pickup_or_delivery_in_order_modal >= k)) {
                                continue;
                            }


                            let currentTimeHasReachedTheMaxOrderLimit = false;
                            if (prevDataTime && i == 0) { // Only for today
                                if (this.props.futureOrders) {
                                    currentTimeHasReachedTheMaxOrderLimit = this.checkTimeMatch(this.props.futureOrders, prevDataTime, Utils.getSettingsValue(settings, 'max_orders_in_hours'));
                                }
                            }

                            if (!currentTimeHasReachedTheMaxOrderLimit) {
                                eachDateHours.push((prevDataTime ? prevDataTime : '') + (minorderTimeHours + j) + ':' + (Utils.appendLeadingZeroes(k)));
                            } else {
                                // console.log('NOT PUSH');
                            }

                            if (enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal == '1') {
                                prevDataTime = (minorderTimeHours + j) + ':' + (Utils.appendLeadingZeroes(k)) + ' - ';
                            }

                        }

                    }

                }

                orderDates.push({
                    value: eachDateValue,
                    label: label,
                    eachDateHours: eachDateHours
                })
            }

        }

        // Remove first 2 rows for 15 mins, except "now"
        if (orderDates && orderDates[0] && orderDates[0].eachDateHours && orderDates[0].eachDateHours[1]) {
            delete orderDates[0].eachDateHours[1];
        }

        // Remove first 2 rows for 15 mins, except "now"
        if (orderDates && orderDates[0] && orderDates[0].eachDateHours && orderDates[0].eachDateHours[2]) {
            delete orderDates[0].eachDateHours[2];
        }

        // Remove first 2 rows for 15 mins, except "now"
        if (orderDates && orderDates[0] && orderDates[0].eachDateHours && orderDates[0].eachDateHours[3]) {
            delete orderDates[0].eachDateHours[3];
        }

        let selectedDate = 0;
        if (this.state.orderDate) {
            selectedDate = orderDates.findIndex(d => d.value == this.state.orderDate)
        }

        let defaultOrderDate = '';
        let defaultOrderTime = '';
        defaultOrderDate = orderDates && orderDates[0] && orderDates[0].value ? orderDates[0].value : ''

        defaultOrderTime = Utils.getSettingsValue(settings, 'required_delivery_pickup_times') != '1' ?
            (orderDates && orderDates[selectedDate] && orderDates[selectedDate].eachDateHours && orderDates[selectedDate].eachDateHours[0] ? orderDates[selectedDate].eachDateHours[0] : '')
            : '';

        this.orderDates = orderDates;
        this.defaultOrderDate = defaultOrderDate;
        this.defaultOrderTime = defaultOrderTime;

        if (currOpenedModal != "served_on_spot") {
            if (!this.state.orderDate && !this.state.orderTime && Utils.getSettingsValue(settings, 'required_delivery_pickup_times') != '1') {
                this.setState({ orderDate: defaultOrderDate, orderTime: defaultOrderTime });
            } else if (!this.state.orderDate) {
                this.setState({ orderDate: defaultOrderDate });
            } else if (!this.state.orderTime && Utils.getSettingsValue(settings, 'required_delivery_pickup_times') != '1') {
                this.setState({ orderTime: defaultOrderTime });
            }
        } else {
            this.setState({ orderTime: '' });
        }

    }

    onChange = (e) => {
        if (e.target.name == 'orderDate') {

            this.setState({
                [e.target.name]: e.target.value,
                orderTime:
                    (this.orderDates
                        && this.orderDates[this.orderDates.findIndex(d => d.value == e.target.value)]
                        && this.orderDates[this.orderDates.findIndex(d => d.value == e.target.value)].eachDateHours
                        && this.orderDates[this.orderDates.findIndex(d => d.value == e.target.value)].eachDateHours[0]
                        ? (((Utils.getSettingsValue(this.props.settings, 'enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal') == '1') && (this.orderDates[this.orderDates.findIndex(d => d.value == e.target.value)].eachDateHours[0].indexOf(' - ') !== -1)) ?
                            this.orderDates[this.orderDates.findIndex(d => d.value == e.target.value)].eachDateHours[0].split(" - ")[0]
                            : this.orderDates[this.orderDates.findIndex(d => d.value == e.target.value)].eachDateHours[0])
                        : (((Utils.getSettingsValue(this.props.settings, 'enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal') == '1') && (this.state.orderTime.indexOf(' - ') !== -1)) ?
                            this.state.orderTime.split(" - ")[0]
                            : this.state.orderTime)
                    )
            })
        } else if (e.target.name == 'orderTime') {

            const newValue = ((Utils.getSettingsValue(this.props.settings, 'enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal') == '1') && (e.target.value.indexOf(' - ') !== -1)) ?
                e.target.value.split(" - ")[0]
                : e.target.value;

            this.setState({
                [e.target.name]: newValue
            })

        } else {
            let targetName = e.target.name;
            let targetValue = e.target.value;

            if (targetName == 'count_cutlery') {
                if (targetValue < 0) {
                    targetValue = 0
                } else if (targetValue > 20) {
                    targetValue = 20
                } else if (!targetValue) {
                    targetValue = 0;
                }
                targetValue = parseInt(targetValue)
            }

            this.setState({ [targetName]: targetValue });
            this.state.formSubmissionFailed ? this.isFormValid({ [targetName]: targetValue }) : void (0);
        }

    }

    onChangeParams = (name, value) => {
        let e = {};
        e.target = {};
        e.target['name'] = name;
        e.target['value'] = value;
        this.onChange(e);
    }

    onChangeCheckbox = (e) => {
        this.setState({ [e.target.name]: e.target.checked });
        this.state.formSubmissionFailed ? this.isFormValid({ [e.target.name]: e.target.checked }) : void (0);
    }

    applyPromocode = () => {
        this.setState({ promoCodeApplied: true })

        let currOrderTypeId = 0;
        if (this.props.chosenPlaceOrderTypes) {
            let currOrderType = this.props.chosenPlaceOrderTypes.find(ot => ot.type == this.props.currOpenedModal)
            if (currOrderType && currOrderType.id) {
                currOrderTypeId = currOrderType.id
            }
        }

        this.props.applyPromocode(this.state.promoCode, currOrderTypeId);
    }

    render() {
        const { classes, fullWidth = false, maxWidth = 'xs', open, onClose, onSubmit, onError, isLoadingOrder, settings, modalData, translations, productsToOrder, productIngredients, chosenPlace, regions, currOpenedModal, registeredUserDiscount, futureOrders } = this.props;
        const userToken = Auth.getUserToken();
        const default_currency_suffix = (settings.default_currency_suffix && settings.default_currency_suffix.value ? settings.default_currency_suffix.value : 'лв.')

        // Prices
        const currentPrice = chosenPlace ? parseFloat(Utils.calculateTotalPriceForOrder(productsToOrder, settings, productIngredients, (this.props.currOpenedModal == 'delivery' || this.props.currOpenedModal == 'preorder'))) : null;
        const orderTypeDiscount = chosenPlace ? Utils.getOrderTypeDiscount(chosenPlace, currOpenedModal, currentPrice, 1) : null;
        const orderTypePrice = chosenPlace ? Utils.getOrderTypePrice(chosenPlace, currOpenedModal, currentPrice, 1) : null;
        const boxesPrice = chosenPlace ? Utils.calculateBoxesForProducts(productsToOrder, settings, this.props.currOpenedModal, productIngredients, 1, true) : null;
        const orderDiscountMoneyForProducts = chosenPlace ? Utils.calculateOrderDiscountMoneyForProducts(productsToOrder, settings, productIngredients, 1) : null;

        let finalPrice = chosenPlace
            ?
            Utils.calculateFinalPriceForOrder
                (currOpenedModal,
                    productsToOrder,
                    settings,
                    productIngredients,
                    regions,
                    this.state.regionId,
                    chosenPlace,
                    (this.props.currOpenedModal == 'delivery' || this.props.currOpenedModal == 'preorder'),
                    this.props.promocodeData,
                    registeredUserDiscount,
                    this.state.deliveryRadiusId,
                    this.state.deliveryShapeId,
                    this.state.count_cutlery,
                    true,
                    this.state.accumulatedOrderAmountUsed
                )
            :
            null;

        let usedAccumulatedOrderAmount = Utils.calculateUsedAccumulatedOrderAmount(this.state.accumulatedOrderAmountUsed, finalPrice);

        finalPrice = parseFloat(Utils.round(finalPrice - usedAccumulatedOrderAmount)).toFixed(2);

        const finalPriceWithoutDelivery = chosenPlace
            ?
            Utils.calculateFinalPriceForOrder
                (currOpenedModal,
                    productsToOrder,
                    settings,
                    productIngredients,
                    regions,
                    this.state.regionId,
                    chosenPlace,
                    (this.props.currOpenedModal == 'delivery' || this.props.currOpenedModal == 'preorder'),
                    this.props.promocodeData,
                    registeredUserDiscount,
                    this.state.deliveryRadiusId,
                    this.state.deliveryShapeId,
                    this.state.count_cutlery,
                    false
                )
            :
            null
            ;

        let selectedRegionDeliveryPrice = 0;
        if (this.props.regions.length > 0 && this.state.regionId) {
            let selectedRegion = (this.props.regions).find(r => r.id == this.state.regionId);
            selectedRegionDeliveryPrice = selectedRegion && selectedRegion.delivery_price ? selectedRegion.delivery_price : selectedRegionDeliveryPrice
        }

        let currentOrderType = 2;
        if (this.props.currOpenedModal == 'spot') {
            currentOrderType = 1;
        } else if (this.props.currOpenedModal == 'delivery') {
            currentOrderType = 2;
        } else if (this.props.currOpenedModal == 'preorder') {
            currentOrderType = 3;
        } else if (this.props.currOpenedModal == 'room') {
            currentOrderType = 6;
        } else if (this.props.currOpenedModal == 'served_on_spot') {
            currentOrderType = 7;
        }

        const multipleOptionsModal = this.props.chosenPlaceOrderTypes.length > 1;
        const isMultipleOptionsModal = (multipleOptionsModal && this.state.modalType == 0) && this.props.scan_modal_open == 0;

        let disabledOrdering = Utils.disabledOrdering(settings);
        // 

        let deliveryRadius = null;
        if (Utils.getDeliveryRadiuses() && this.state.deliveryRadiusId) {
            deliveryRadius = Utils.getDeliveryRadiuses().find(r => r.id == this.state.deliveryRadiusId);
        }

        let deliveryShape = null;
        if (Utils.getDeliveryShapes() && this.state.deliveryShapeId) {
            deliveryShape = Utils.getDeliveryShapes().find(r => r.id == this.state.deliveryShapeId);
        }

        return (
            <React.Fragment>
                <Dialog
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                    open={!!open}
                    // open={1}
                    onClose={onClose}
                    aria-labelledby="max-width-dialog-title"
                    TransitionComponent={Grow}
                    className={classes.modal}
                    data-class="dialog-container"
                >
                    <DialogTitle id="max-width-dialog-title" className={classes.modalTitle} style={{ textAlign: 'center', color: 'white', boxShadow: '0 1px 5px 0px black' }} data-class="dialog-title-container">
                        {this.props.currOpenedModal == 'spot' ? (translations.pages && translations.pages.cart_delivery ? <span style={this.props.currOpenedModal == 'spot' ? {} : { display: 'none' }}>{translations.pages.cart_delivery.scan_barcode}</span> : '') : ''}
                        {this.props.currOpenedModal == 'delivery' ? (translations.pages && translations.pages.cart_delivery ? <span style={this.props.currOpenedModal == 'delivery' ? {} : { display: 'none' }}>{translations.pages.cart_delivery.order_type_delivery}</span> : '') : ''}
                        {this.props.currOpenedModal == 'preorder' ? (translations.pages && translations.pages.cart_delivery ? <span style={this.props.currOpenedModal == 'preorder' ? {} : { display: 'none' }}>{translations.pages.cart_delivery.order_type_preorder}</span> : '') : ''}
                        {this.props.currOpenedModal == 'room' ? (translations.pages && translations.pages.cart_delivery ? <span style={this.props.currOpenedModal == 'room' ? {} : { display: 'none' }}>{Utils.getSettingsValue(settings, 'custom_translations') && Utils.getSettingsValue(settings, 'custom_translations').room_modal_title ? Utils.getSettingsValue(settings, 'custom_translations').room_modal_title : translations.pages.cart_delivery.order_type_room}</span> : '') : ''}
                        {this.props.currOpenedModal == 'served_on_spot' ? (translations.pages && translations.pages.cart_delivery ? <span style={this.props.currOpenedModal == 'served_on_spot' ? {} : { display: 'none' }}>{translations.pages.cart_delivery.order_type_served_on_spot}</span> : '') : ''}
                        {this.props.currOpenedModal == 'multiple' ? (translations.pages && translations.pages.cart_delivery ? <span style={this.props.currOpenedModal == 'multiple' ? {} : { display: 'none' }}>{translations.pages.cart_delivery.choose_order_type}</span> : '') : ''}
                    </DialogTitle>
                    <DialogContent ref={this.dialogContentRef} style={this.props.currOpenedModal == 'multiple' || this.props.currOpenedModal == 'spot' ? { padding: 0 } : {}}>

                        {Utils.getSettingsValue(settings, 'orders_may_be_late') == '1' && this.props.currOpenedModal == 'multiple' ?
                            <div style={{
                                textAlign: 'center',
                                background: '#ffeb00',
                                padding: 5,
                                paddingTop: 10,
                            }}>
                                Уважаеми клиенти, поради обема на работа, е възможно забавяне на вашата поръчка. Благодарим за разбирането!
                            </div>
                            :
                            null
                        }

                        {this.state.alertMessage &&
                            <>
                                <SnackbarContent
                                    className={classes.snackbarMessageStyles}
                                    message={this.state.alertMessage}
                                />
                            </>

                        }


                        <Backdrop open={isLoadingOrder} className={classes.backdrop}>
                            <CircularProgress className="is-loading" />
                        </Backdrop>


                        {(this.props.currOpenedModal == 'delivery' && Utils.getSettingsValue(settings, 'delivery_modal_info_text') && (Utils.getSettingsValue(settings, 'delivery_modal_info_text_position') == 'header')) ?
                            <div style={{ textAlign: 'center', marginTop: 25 }}
                                dangerouslySetInnerHTML={{
                                    __html: Utils.getSettingsValue(settings, 'delivery_modal_info_text')
                                }}></div>
                            :
                            null
                        }

                        {(this.props.currOpenedModal == 'preorder' && Utils.getSettingsValue(settings, 'preorder_modal_info_text') && (Utils.getSettingsValue(settings, 'preorder_modal_info_text_position') == 'header')) ?
                            <div style={{ textAlign: 'center', marginTop: 25 }}
                                dangerouslySetInnerHTML={{
                                    __html: Utils.getSettingsValue(settings, 'preorder_modal_info_text')
                                }}></div>
                            :
                            null
                        }


                        {(this.props.currOpenedModal == 'room' && Utils.getSettingsValue(settings, 'room_modal_info_text') && (Utils.getSettingsValue(settings, 'room_modal_info_text_position') == 'header')) ?
                            <div style={{ textAlign: 'center', marginTop: 25 }}
                                dangerouslySetInnerHTML={{
                                    __html: Utils.getSettingsValue(settings, 'room_modal_info_text')
                                }}></div>
                            :
                            null
                        }



                        {this.props.currOpenedModal == 'multiple' ?
                            <React.Fragment>
                                {disabledOrdering ?
                                    <div className={classes.orderDisabledContainer}>
                                        {Utils.getDisabledOrderingMessage(translations, settings)}
                                    </div>
                                    :
                                    null
                                }

                                <div className={classes.isMultipleOptionsModalContainer} style={{ marginTop: (Utils.getSettingsValue(settings, 'orders_may_be_late') == '1' ? 20 : 40) }}>
                                    {this.getOrderOptions(currentPrice, selectedRegionDeliveryPrice)}
                                </div>

                            </React.Fragment>
                            :
                            this.props.currOpenedModal == 'spot' || this.props.scan_modal_open ?
                                <OrderModalSpot
                                    onClose={this.props.onClose}
                                    onError={this.props.onError}
                                    handleScanError={this.handleScanError}
                                    handleScan={this.handleScan}
                                    orderMessage={this.props.orderMessage}
                                    orderSent={this.props.orderSent}
                                />
                                :
                                this.props.currOpenedModal == 'delivery' ?
                                    <OrderModalDelivery
                                        currOpenedModal={this.props.currOpenedModal}
                                        onChangeParams={this.onChangeParams}
                                        onChange={(e) => this.onChange(e)}
                                        onChangeCheckbox={(e) => this.onChangeCheckbox(e)}
                                        onClick={(name, value) => this.setState({ [name]: value })}
                                        onError={this.props.onError}
                                        omdata={this.state}
                                        orderDates={this.orderDates}
                                        defaultOrderDate={this.defaultOrderDate}
                                        defaultOrderTime={this.defaultOrderTime}
                                        orderMessage={this.props.orderMessage}
                                        orderSent={this.props.orderSent}
                                        currentPrice={currentPrice}
                                        orderTypePrice={orderTypePrice}
                                        currentOrderType={currentOrderType}
                                        submitOrder={this.submitOrder}
                                        applyPromocode={this.applyPromocode}
                                        promocodeData={this.props.promocodeData}
                                        setCutleryItemsCount={this.setCutleryItemsCount}
                                        futureOrders={this.props.futureOrders}
                                        finalPrice={finalPrice}
                                    />
                                    :
                                    this.props.currOpenedModal == 'preorder' ?
                                        <OrderModalPreorder
                                            currOpenedModal={this.props.currOpenedModal}
                                            onChangeParams={this.onChangeParams}
                                            onChange={(e) => this.onChange(e)}
                                            onChangeCheckbox={(e) => this.onChangeCheckbox(e)}
                                            onClick={(name, value) => this.setState({ [name]: value })}
                                            onError={this.props.onError}
                                            omdata={this.state}
                                            orderDates={this.orderDates}
                                            defaultOrderDate={this.defaultOrderDate}
                                            defaultOrderTime={this.defaultOrderTime}
                                            orderMessage={this.props.orderMessage}
                                            orderSent={this.props.orderSent}
                                            currentOrderType={currentOrderType}
                                            submitOrder={this.submitOrder}
                                            applyPromocode={this.applyPromocode}
                                            promocodeData={this.props.promocodeData}
                                            setCutleryItemsCount={this.setCutleryItemsCount}
                                            futureOrders={this.props.futureOrders}
                                            finalPrice={finalPrice}
                                        />
                                        :
                                        this.props.currOpenedModal == 'room' ?
                                            <OrderModalRoom
                                                currOpenedModal={this.props.currOpenedModal}
                                                onChangeParams={this.onChangeParams}
                                                onChange={(e) => this.onChange(e)}
                                                onChangeCheckbox={(e) => this.onChangeCheckbox(e)}
                                                onClick={(name, value) => this.setState({ [name]: value })}
                                                onError={this.props.onError}
                                                omdata={this.state}
                                                orderDates={this.orderDates}
                                                defaultOrderDate={this.defaultOrderDate}
                                                defaultOrderTime={this.defaultOrderTime}
                                                orderMessage={this.props.orderMessage}
                                                orderSent={this.props.orderSent}
                                                currentOrderType={currentOrderType}
                                                submitOrder={this.submitOrder}
                                                applyPromocode={this.applyPromocode}
                                                promocodeData={this.props.promocodeData}
                                                finalPrice={finalPrice}
                                            />
                                            :
                                            this.props.currOpenedModal == 'served_on_spot' ?
                                                <OrderModalServedOnSpot
                                                    currOpenedModal={this.props.currOpenedModal}
                                                    onChangeParams={this.onChangeParams}
                                                    onChange={(e) => this.onChange(e)}
                                                    onChangeCheckbox={(e) => this.onChangeCheckbox(e)}
                                                    onClick={(name, value) => this.setState({ [name]: value })}
                                                    onError={this.props.onError}
                                                    omdata={this.state}
                                                    orderDates={this.orderDates}
                                                    defaultOrderDate={this.defaultOrderDate}
                                                    defaultOrderTime={this.defaultOrderTime}
                                                    orderMessage={this.props.orderMessage}
                                                    orderSent={this.props.orderSent}
                                                    currentOrderType={currentOrderType}
                                                    submitOrder={this.submitOrder}
                                                    applyPromocode={this.applyPromocode}
                                                    promocodeData={this.props.promocodeData}
                                                    finalPrice={finalPrice}
                                                />
                                                :
                                                null
                        }

                        {/* {this.props.currOpenedModal != 'multiple' && this.props.currOpenedModal != 'spot' ?
                            <br />
                            :
                            null
                        } */}

                        {this.props.currOpenedModal != 'multiple' && this.props.currOpenedModal != 'spot' ?
                            <div className={classes.priceOrderContainer} data-class="price-order-container">
                                <p style={{ width: '100%' }}>
                                    <span>
                                        {Utils.getDeliveryRadiuses() && finalPriceWithoutDelivery != currentPrice ?
                                            translations && translations.common && translations.common.amount ? translations.common.amount : ''
                                            :
                                            translations && translations.common && translations.common.subtotal ? translations.common.subtotal : ''
                                        }
                                        :
                                    </span>
                                    <span>{currentPrice.toFixed(2) + ' ' + default_currency_suffix}</span>
                                </p>

                                {orderTypeDiscount && Object.keys(orderTypeDiscount).length > 0 && (this.props.promocodeData && (Object.values(this.props.promocodeData).length == 0 || (this.props.promocodeData && this.props.promocodeData.payload && this.props.promocodeData.payload.found == false) || ((this.props.promocodeData && this.props.promocodeData.payload && this.props.promocodeData.payload.found && !this.props.promocodeData.payload.ignore_other_discounts)))) ?
                                    <p>
                                        <span>{translations && translations.common && translations.common.discount ? translations.common.discount : ''}:</span>
                                        <span>{orderTypeDiscount.value_type == 'money' ? orderTypeDiscount.value : parseInt(orderTypeDiscount.value)}{orderTypeDiscount.value_type == 'money' ? ' ' + default_currency_suffix : '%'}</span>
                                    </p>
                                    :
                                    null
                                }


                                {/* Registered user discount */}
                                {registeredUserDiscount && registeredUserDiscount.discount && registeredUserDiscount.ordersCount && parseInt(registeredUserDiscount.discount.on_order_number) == (parseInt(registeredUserDiscount.ordersCount) + 1) ?
                                    <p>
                                        <span>{translations && translations.common && translations.common.personal_discount ? translations.common.personal_discount : ''}:</span>
                                        <span>{registeredUserDiscount.discount.discount_type == 'money' ? registeredUserDiscount.discount.discount_amount : parseInt(registeredUserDiscount.discount.discount_amount)}{registeredUserDiscount.discount.discount_type == 'money' ? ' ' + default_currency_suffix : '%'}</span>
                                    </p>
                                    :
                                    null
                                }

                                {/* Accumulated order user discount */}
                                {Auth.getDecodedUser() && this.props.accumulatedOrderAmountSetting && this.state.accumulatedOrderAmountUsed ?
                                    <p>
                                        <span>{translations && translations.common && translations.common.personal_discount ? translations.common.personal_discount : ''}:</span>
                                        <span>{usedAccumulatedOrderAmount} {default_currency_suffix}</span>
                                    </p>
                                    :
                                    null
                                }

                                {this.props.promocodeData && this.props.promocodeData.payload && this.props.promocodeData.payload.found ?
                                    <p>
                                        <span>{translations && translations.common && translations.common.discount_promocode ? translations.common.discount_promocode : ''}:</span>

                                        {this.props.promocodeData.payload.ignore_other_discounts ?
                                            <React.Fragment>
                                                <ClickAwayListener
                                                    onClickAway={() => this.setState({ promocodeTooltipOpened: false })}
                                                >
                                                    <div>
                                                        <Tooltip
                                                            PopperProps={{
                                                                disablePortal: true,
                                                            }}
                                                            // onClose={() => this.hideOrderTooltip(item.id)}
                                                            open={this.state.promocodeTooltipOpened}
                                                            disableFocusListener
                                                            disableHoverListener
                                                            disableTouchListener
                                                            title={translations && translations.promocode && translations.promocode.others_discounts_are_not_applied ? translations.promocode.others_discounts_are_not_applied : ''}
                                                        >
                                                            <div
                                                                style={{ textAlign: 'right' }}
                                                                onClick={() => this.state.promocodeTooltipOpened ? void (0) : this.setState({ promocodeTooltipOpened: true })}
                                                                onMouseOver={() => this.setState({ promocodeTooltipOpened: true })}
                                                            // onMouseOut={() => this.hideOrderTooltip(item.id)}
                                                            >
                                                                {this.props.promocodeData.payload.discount_type == 'money' ? this.props.promocodeData.payload.discount_value : parseInt(this.props.promocodeData.payload.discount_value)}{this.props.promocodeData.payload.discount_type == 'money' ? ' ' + default_currency_suffix : '%'}
                                                                &nbsp;
                                                                <Info style={{ verticalAlign: '-6', marginRight: 3 }} />
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                </ClickAwayListener>
                                            </React.Fragment>
                                            :
                                            <span>{this.props.promocodeData.payload.discount_type == 'money' ? this.props.promocodeData.payload.discount_value : parseInt(this.props.promocodeData.payload.discount_value)}{this.props.promocodeData.payload.discount_type == 'money' ? ' ' + default_currency_suffix : '%'}</span>
                                        }
                                    </p>
                                    :
                                    null
                                }

                                {(this.props.currOpenedModal == 'delivery' || this.props.currOpenedModal == 'preorder') && Utils.getSettingsValue(settings, 'additional_price_each_cutlery') && Utils.getSettingsValue(settings, 'additional_price_each_cutlery') != '0' ?
                                    <p>
                                        <span>{translations && translations.common && translations.common.cutleries ? translations.common.cutleries : ''}:</span>
                                        <span>
                                            {parseFloat(parseInt(this.state.count_cutlery) * parseFloat(Utils.getSettingsValue(settings, 'additional_price_each_cutlery'))).toFixed(2) + ' ' + default_currency_suffix}
                                        </span>
                                    </p>
                                    :
                                    null
                                }


                                {
                                    (this.props.currOpenedModal == 'preorder' && Utils.getSettingsValue(settings, 'calculate_product_box_only_for_preorder_orders') == '1')
                                        || Utils.getSettingsValue(settings, 'calculate_product_box_only_for_preorder_orders') != '1'
                                        ?
                                        <p>
                                            <span>{translations && translations.common && translations.common.boxes_prices ? translations.common.boxes_prices : ''}:</span>
                                            <span>
                                                {boxesPrice} {default_currency_suffix}
                                            </span>
                                        </p>
                                        :
                                        null
                                }



                                {this.props.currOpenedModal == 'preorder' && Utils.getSettingsValue(settings, 'calculate_product_discount_money_only_for_preorder_orders') && Utils.getSettingsValue(settings, 'calculate_product_discount_money_only_for_preorder_orders') == '1' ?
                                    <p>
                                        <span>{translations && translations.common && translations.common.discount ? translations.common.discount : ''}:</span>
                                        <span>
                                            {orderDiscountMoneyForProducts} {default_currency_suffix}
                                        </span>
                                    </p>
                                    :
                                    null
                                }


                                {((Utils.getDeliveryRadiuses() || Utils.getDeliveryShapes()) && (finalPriceWithoutDelivery != currentPrice) && (Utils.getSettingsValue(settings, 'calculate_product_box_only_for_preorder_orders') && Utils.getSettingsValue(settings, 'calculate_product_box_only_for_preorder_orders') != '1')) ?
                                    <p>
                                        <span><i>{translations && translations.common && translations.common.subtotal ? translations.common.subtotal : ''}:</i></span>
                                        <span><i>{finalPriceWithoutDelivery ? (parseFloat(finalPriceWithoutDelivery).toFixed(2) + ' ' + default_currency_suffix) : ''}</i></span>
                                    </p>
                                    :
                                    null
                                }

                                {this.props.currOpenedModal == 'delivery' ?
                                    <p>
                                        <span>{translations && translations.common && translations.common.delivery ? translations.common.delivery : ''}:</span>
                                        {
                                            Utils.getDeliveryShapes() ?
                                                this.state.deliveryShapeId ?
                                                    <span> {/* NEW LOGIC FOR DELIVERY PRICE - GOOGLE MAPS SHAPES PRICES*/}
                                                        {/* ако финалната цена - цената на доставка (тоест цената на всички продукти с отстъпките ако има такива) е > от required_order_price_for_free_delivery -> free доставка */}
                                                        {finalPriceWithoutDelivery * 1 >= deliveryShape.required_order_price_for_free_delivery * 1 && deliveryShape.required_order_price_for_free_delivery * 1 > 0 ?
                                                            (translations && translations.common && translations.common.free_del ? translations.common.free_del : '')
                                                            :
                                                            deliveryShape.delivery_price + ' ' + default_currency_suffix}
                                                    </span>
                                                    :
                                                    <span>-</span>
                                                :
                                                Utils.getDeliveryRadiuses() ?
                                                    this.state.deliveryRadiusId ?
                                                        <span> {/* NEW LOGIC FOR DELIVERY PRICE - GOOGLE MAPS RADIUSES PRICES*/}
                                                            {/* ако финалната цена - цената на доставка (тоест цената на всички продукти с отстъпките ако има такива) е > от required_order_price_for_free_delivery -> free доставка */}
                                                            {finalPriceWithoutDelivery * 1 >= deliveryRadius.required_order_price_for_free_delivery * 1 && deliveryRadius.required_order_price_for_free_delivery * 1 > 0 ?
                                                                (translations && translations.common && translations.common.free_del ? translations.common.free_del : '')
                                                                :
                                                                deliveryRadius.delivery_price + ' ' + default_currency_suffix}
                                                        </span>
                                                        :
                                                        <span>-</span>
                                                    :
                                                    <span>  {/* OLD LOGIC FOR DELIVERY PRICE */}
                                                        {orderTypePrice.value ? (parseFloat(orderTypePrice.value) == 0 ? (translations && translations.common && translations.common.free_del ? translations.common.free_del : '') : (orderTypePrice.value + ' ' + default_currency_suffix)) : selectedRegionDeliveryPrice + ' ' + default_currency_suffix}
                                                    </span>
                                        }

                                    </p>
                                    :
                                    null
                                }

                                <p style={{ fontWeight: 'bold' }}>
                                    <span>{translations && translations.common && translations.common.final_price ? translations.common.final_price : ''}:</span>
                                    <span>{finalPrice} {default_currency_suffix}</span>
                                </p>
                            </div>
                            :
                            null
                        }


                        {(this.props.currOpenedModal == 'delivery' && Utils.getSettingsValue(settings, 'delivery_modal_info_text') && (Utils.getSettingsValue(settings, 'delivery_modal_info_text_position') == 'footer')) ?
                            <div style={{ textAlign: 'center' }}
                                dangerouslySetInnerHTML={{
                                    __html: Utils.getSettingsValue(settings, 'delivery_modal_info_text')
                                }}></div>
                            :
                            null
                        }

                        {(this.props.currOpenedModal == 'preorder' && Utils.getSettingsValue(settings, 'preorder_modal_info_text') && (Utils.getSettingsValue(settings, 'preorder_modal_info_text_position') == 'footer')) ?
                            <div style={{ textAlign: 'center' }}
                                dangerouslySetInnerHTML={{
                                    __html: Utils.getSettingsValue(settings, 'preorder_modal_info_text')
                                }}></div>
                            :
                            null
                        }

                        {(this.props.currOpenedModal == 'room' && Utils.getSettingsValue(settings, 'room_modal_info_text') && (Utils.getSettingsValue(settings, 'room_modal_info_text_position') == 'footer')) ?
                            <div style={{ textAlign: 'center' }}
                                dangerouslySetInnerHTML={{
                                    __html: Utils.getSettingsValue(settings, 'room_modal_info_text')
                                }}></div>
                            :
                            null
                        }


                    </DialogContent>
                    {
                        this.props.currOpenedModal != 'multiple' && this.props.currOpenedModal != 'spot' ?
                            <DialogActions style={{ display: 'block' }}>

                                {!Auth.getTokenOrderType() && this.props.chosenPlaceOrderTypes.length > 1 ?
                                    <Button
                                        id="selected-order-type-modal-cancel-button"
                                        onClick={() => {
                                            this.setState({ errors: '' });
                                            multipleOptionsModal ? this.setState({ modalType: 0 }) : onClose();
                                            this.props.closeScanModal();
                                            this.props.setCurrOpenedModal('multiple')
                                        }}
                                        style={{ color: 'black' }}
                                    >
                                        {multipleOptionsModal ? (translations.common ? translations.common.action.back : '') : (translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.cancel : '')}
                                    </Button>
                                    :
                                    null
                                }

                                {this.props.currOpenedModal != 'spot' ?

                                    
                                    <Button
                                        id="selected-order-type-modal-submit-button"
                                        onClick={() => this.submitOrder(currentOrderType)}
                                        style={{ color: '#FE6902', fontWeight: 'bold', float: 'right' }}
                                    >
                                        {translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.make_order : ''}
                                        {/* {Utils.calculateFinalPriceForOrder(this.props.currOpenedModal, this.props.productsToOrder, this.props.settings, this.props.productIngredients, this.props.regions, this.state.regionId, this.props.chosenPlace, 1)} */}
                                    </Button>
                                    :
                                    null
                                }
                            </DialogActions>
                            :
                            null
                    }

                </Dialog >

            </React.Fragment >
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let chosenPlaceOrderTypes = [];
    let deliveryShapes = [];
    let chosenPlaceId = state.places.chosen_place;
    let chosenPlace = state.places.places.filter(p => p.id == chosenPlaceId);
    if (chosenPlace.length == 0) {
        chosenPlace = null;
    } else {
        chosenPlace = chosenPlace[0];
        chosenPlaceOrderTypes = chosenPlace.ordertypes;

        let deliveryOrderType = chosenPlaceOrderTypes.find(o => o.type == 'delivery');
        if (deliveryOrderType && deliveryOrderType.delivery_shapes) {
            deliveryShapes = deliveryOrderType.delivery_shapes;
        }
    }

    return {
        isLoadingOrder: state.products.isLoadingOrder || false,
        settings: state.settings.settings || [],
        scan_modal_open: state.scan.scan_modal_open || 0,
        currOpenedModal: state.scan.curr_opened_modal || 'multiple',
        places: state.places.places || [],
        chosenPlace: chosenPlace,
        chosenPlaceOrderTypes: chosenPlaceOrderTypes,
        regions: state.regions.regions || [],
        productsToOrder: Utils.normalizeCartProducts(state.products.to_order) || [],
        productIngredients: state.products.productIngredients || [],
        translations: state.lang.translations,
        loggedUser: state.users.user && Object.keys(state.users.user).length !== 0 ? state.users.user : null,
        orderMessage: state.products.order_message || '',
        orderSent: state.products.order_sent || null,
        promocodeData: state.promocodeData.promocodeData || [],
        registeredUserDiscount: state.registeredUserDiscount.registered_user_discounts || [],
        client: state.client || null,
        deliveryShapes: deliveryShapes,
        futureOrders: state.futureOrders.future_orders_count.orderCounts,
        accumulatedOrderAmountSetting: state.accumulatedOrderAmountSetting.setting

    };
};

export default withStyles(styles)(connect(mapStateToProps, { verifyTokenAndSession, closeScanModal, setCurrOpenedModal, setOrderModalState, verifyOpenedPlace, setAlertMessage, setChosenPlace, applyPromocode, makeSystemLog })(OrderModal));